
import {Component, Vue} from "vue-property-decorator";
import {AppModule} from "@/store/modules/app";
import {UserModule} from "@/store/modules/user";
import Hamburger from "@/components/Hamburger/index.vue";
import SizeSelect from "@/components/SizeSelect/index.vue";
import {TagsViewModule} from "@/store/modules/tags-view";
import {getToken} from "@/utils/cookies";
import {searchHeadUserMails,getDocumentTypes} from "@/api/mails";
import Template from "@/views/system-management/template/index.vue";
import { getUserMail,getSystemMail } from "@/api/mails"
import Pagination from "@/components/Pagination/index.vue";
import { EventBus } from "@/utils/eventBus"

@Component({
  name: "Navbar",
  components: {
    Template,
    Hamburger,
    SizeSelect,
    Pagination
  }
})
export default class extends Vue {
  get sidebar() {
    return AppModule.sidebar;
  }

  get device() {
    return AppModule.device.toString();
  }

  get avatar() {
    return UserModule.avatar;
  }

  get name() {
    return UserModule.name;
  }


  private userMessageData = [];
  private systemMessageData = [];


  created() {
    this.getSocket(`ws://${location.host}/${process.env.VUE_APP_BASE_API}/hq-lms/ws`, [], `token=${getToken()}`, (message, ws) => {
      if (message.data === "1") {
        this.getSystemList(null);
        this.getUserList();
      }
    });
    EventBus.$on('getMailList', (data) => {
      if(data.message === 'getMailList') {
        this.getSystemList(null);
        this.getUserList();
      }
    })
  }
  mounted () {
    this.getDocumentTypes();
    this.getSystemList(null);
    this.getUserList();
  }

  beforeDestroy() {
    EventBus.$off('getMailList')
  }

  private systemPageNumber = 1;
  private systemPageSize = 20;
  private userPageNumber = 1;
  private userPageSize = 20;
  private systemTotal = 0;
  private userTotal = 0;
  private systemLoading = false;
  private userLoading = false;

  private async getSystemList(documentsType) { // 系统消息
    let params = {
      documentsType:documentsType === 'all'?null:documentsType,
      pageNumber: this.systemPageNumber,
      pageSize: this.systemPageSize,
    }
    this.systemLoading = true;
    await getSystemMail(params).then((res:any) => {
      const { content,total } = res
      this.systemMessageData = content;
      this.systemTotal = +total;
      this.systemLoading = false;
    }).catch(err => {
      console.log(err)
    });
  }
  private async getUserList() { // 新消息
    let params = {
      pageNumber: this.userPageNumber,
      pageSize: this.userPageSize,
    }
    this.userLoading = true;
    await getUserMail(params).then((res:any) => {
      const { content,total } = res
      this.userMessageData = content;
      this.userTotal = +total;
      this.userLoading = false;
    }).catch(err => {
      console.log(err);
      this.userLoading = false;
    });
  }

  private goToMailDetail() {
    // 避免 自己跳自己
    if(this.$route.path !== '/mailsDetail') {
      this.$router.push({path: `/mailsDetail`});
    }
    if( this.$refs && this.$refs.systemPopover ) {
      (this.$refs.systemPopover as any).doClose()
    }
    if( this.$refs && this.$refs.userPopover ) {
      (this.$refs.userPopover as any).doClose()
    }
  }

  private getSocket(url, Authorization, params, callback) {
    let socket;
    if (typeof WebSocket === "undefined") {
    } else {
      // console.log("您的浏览器支持WebSocket"); // 初始化 WebSocket 对象，指定要连接的服务器地址与端口建立连接

      socket = new WebSocket(url, Authorization);
      socket.onopen = () => {
        // 打开发送消息
        socket.send(params);
      }; // 获得消息事件
      socket.onmessage = (msg) => {
        // 发现消息进入, 开始处理前端触发逻辑
        callback(msg, socket);
      }; // 关闭事件

      socket.onclose = () => {
        // console.log("Socket 已关闭");
      }; // 发生了错误事件

      socket.onerror = (err) => {
        // console.log("Socket 发生了错误,请刷新页面", err); // 此时可以尝试刷新页面
      };
    }
  }

  private AllTypes = [];

  private tabName = 'all';

  private changeTablClick(e) {
    this.tabName = e.name;
    this.getSystemList(e.name);
  }

  private newNotice() {
    this.tabName = 'all';
    this.getUserList();
  }
  private newSystemNotice() {
    this.tabName = 'all';
    this.getSystemList('all');
  }

  private async getDocumentTypes() {
    const res: any = await getDocumentTypes();
    this.AllTypes = res;
    this.AllTypes.unshift({desc:'全部',name: 'all'});
  }

  private toggleSideBar() {
    AppModule.ToggleSideBar(false);
  }

  private async logout() {
    await UserModule.Logout();
    TagsViewModule.delAllViews();
    await this.$router.push(`/login`);
    location.reload();
  }
}
